class HollywoodStarfield extends HTMLElement {
  connectedCallback() {
    this.canvas = this.querySelector('canvas');
    if (!this.canvas || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.context = this.canvas.getContext('2d');
    this.resize = this.resize.bind(this);
    this.draw = this.draw.bind(this);
    addEventListener('resize', this.resize, { passive: true });
    this.resize();
    this.frame = requestAnimationFrame(this.draw);
  }

  disconnectedCallback() {
    removeEventListener('resize', this.resize);
    cancelAnimationFrame(this.frame);
  }

  resize() {
    const bounds = this.getBoundingClientRect();
    this.dpr = Math.min(devicePixelRatio || 1, 2);
    this.width = Math.max(1, bounds.width);
    this.height = Math.max(1, bounds.height);
    this.focalLength = Math.max(260, this.width * 0.34);

    this.canvas.width = this.width * this.dpr;
    this.canvas.height = this.height * this.dpr;
    this.canvas.style.width = `${this.width}px`;
    this.canvas.style.height = `${this.height}px`;
    this.context.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);

    const starCount = Math.min(190, Math.floor((this.width * this.height) / 6500));
    this.stars = Array.from({ length: starCount }, () => this.makeStar(true));
  }

  makeStar(randomDepth = false) {
    const depth = randomDepth
      ? 140 + Math.random() * 760
      : 720 + Math.random() * 180;
    const screenX = (Math.random() - 0.5) * this.width * 1.5;
    const screenY = (Math.random() - 0.5) * this.height * 1.5;

    return {
      x: screenX * depth / this.focalLength,
      y: screenY * depth / this.focalLength,
      z: depth,
      opacity: 0.34 + Math.random() * 0.64,
      size: 0.8 + Math.random() * 1.15
    };
  }

  draw() {
    const context = this.context;
    context.clearRect(0, 0, this.width, this.height);

    this.stars.forEach((star, index) => {
      star.z -= 0.24;
      if (star.z < 90) {
        this.stars[index] = this.makeStar();
        return;
      }

      const scale = this.focalLength / star.z;
      const x = star.x * scale + this.width / 2;
      const y = star.y * scale + this.height / 2;

      if (x < -12 || x > this.width + 12 || y < -12 || y > this.height + 12) {
        this.stars[index] = this.makeStar();
        return;
      }

      const closeness = Math.max(0, Math.min(1, 1 - star.z / 900));
      const radius = Math.min(3.4, star.size * (0.75 + closeness * 2.5));
      context.globalAlpha = star.opacity * (0.58 + closeness * 0.42);
      context.fillStyle = '#fff';
      context.shadowColor = 'rgba(255, 255, 255, 0.7)';
      context.shadowBlur = closeness > 0.58 ? radius * 2.4 : 0;
      context.beginPath();
      context.arc(x, y, radius, 0, Math.PI * 2);
      context.fill();
    });

    context.globalAlpha = 1;
    context.shadowBlur = 0;
    this.frame = requestAnimationFrame(this.draw);
  }
}

if (!customElements.get('hollywood-starfield')) {
  customElements.define('hollywood-starfield', HollywoodStarfield);
}
